import { Model } from 'backbone';
import _ from 'lodash';
// import moment from 'moment';

export class MatchUpModel extends Model {
	get total_match_mins() {
		return 80;
	}

	get period_match_mins() {
		return 40;
	}

	setMatchUpFixture({ league, home_team, away_team, round_id, selected_round, players }) {
		let is_match_active = selected_round.is_match_active,
			fixture = _.find(league.get('fixture_item'), { is_selected: true }),
			home = this.getFixtureData({
				team: home_team, fixture: fixture.first_opponent, round_id, is_match_active,
				round: selected_round, players
			}),
			away = this.getFixtureData({
				team: away_team, fixture: fixture.second_opponent, round_id, is_match_active,
				round: selected_round, players
			})
		;

		const matchup_fixture = {
			home,
			away
		};

		this.set({
			matchup_fixture
		});

		return this;
	}

	getFixtureData({ team, fixture, round_id, is_match_active, round, players }) {
		const scoreflow_result = _.result(fixture, `scoreflow.${round_id}`, '-'),
			score = is_match_active ? team.get('team_score') : scoreflow_result,
			playing_now = _.filter(team.get('team_players'), player => player.is_playing_now),
			is_playing_now = _.size(playing_now);

		this.countPlayers({ team, round, players });

		return _.assign(team.toJSON(), fixture, {
			avatar_url: team.getAvatarUrl(fixture.user_id),
			ladder_position: _.result(fixture, `rank_history.${round_id}`) || '-',
			score,
			is_playing_now
		});
	}

	getLineupPlayers({ team, players, positions }) {
		let lineup_players = {},
			{ captain, vice_captain } = team.get('lineup'),
			leaders = [captain, vice_captain],
			leaders_classes = ['is-captain', 'is-vice-captain']
		;
		const { not_played = [] } = team.attributes;

		_.each(team.lineup_without_leads, function(line, key) {
			lineup_players[key] = _.map(line, function(id, index) {
				let player = not_played.includes(id) ? {} : _.find(players, { id }),
					leader_class_name = id !== 0 && leaders_classes[leaders.indexOf(id)],
					bench_index = false,
					bench_pos_name = '',
					result = {}
				;

				if (key==='bench') {
					const is_reserve = index < 4;
					bench_index = index + 1;
					bench_pos_name = is_reserve ? 'INT' : 'EMG';
					leader_class_name = is_reserve ? 'is-reserve' : 'is-emergency';
				}
				else {
					result.position = positions[key].short_name;
				}

				_.assign(result, {
					...player,
					leader_class_name,
					bench_index,
					bench_pos_name
				});

				return result;
			});
		});

		return lineup_players;
	}

	setMatchingPlayers({ home_team, away_team }) {
		const ids = _.intersection(home_team.team_players_id, away_team.team_players_id),
			home_matching_players = this.getPlayersFromArray({ team: home_team, ids }),
			away_matching_players = this.getPlayersFromArray({ team: away_team, ids })
		;

		this.set({
			home_matching_players,
			away_matching_players
		}, { silent: true });

		return this;
	}

	setUniquePlayers({ home_team, away_team }) {
		let home_ids = this.getTeamIds({ team: home_team, opponent: away_team, side: 'home' }),
			away_ids = this.getTeamIds({ team: away_team, opponent: home_team, side: 'away' }),
			home_unique_players = this.getPlayersFromArray({ team: home_team, ids: home_ids }),
			away_unique_players = this.getPlayersFromArray({ team: away_team, ids: away_ids })

		;

		this.set({
			home_unique_players,
			away_unique_players
		}, { silent: true });

		return this;
	}

	getTeamIds({ team, opponent, side }) {
		let difference = _.difference(team.team_players_id, opponent.team_players_id),
			max = team.get('max_team_size'),
			matching_size = _.size(_.result(this.toJSON(), side + '_matching_players')),
			current_size = max - matching_size - _.size(difference)
		;

		return _.concat(difference, _.fill(Array(current_size), 0));
	}

	getPlayersFromArray({ team, ids }) {
		const team_players = this.getTeamLineupPLayersModels(team);

		return _.map(ids, id => team_players[id]);
	}

	getTeamLineupPLayersModels(team) {
		return _.chain(team.get('lineup_players'))
			.omit(['captain', 'vice_captain'])
			.values()
			.flatten()
			.keyBy('id')
			.value()
	}

	getChartLabels({ selected_round, squads }) {
		let { matches } = selected_round.toJSON();
		return _.map(matches, function(match) {
			const home = squads.get(match.home_squad_id).get('short_name'),
				away = squads.get(match.away_squad_id).get('short_name')
				// game_date = moment(match.date).format('h:mma')
			;

			return `${home} V ${away}`;
		});
	}

	getTeamsByMatches({ home, away, selected_round }) {
		return {
			home_points: this.getTeamPlayersScoreByMatches({ team: home, selected_round }),
			away_points: this.getTeamPlayersScoreByMatches({ team: away, selected_round }),
		}
	}

	getTeamPlayersScoreByMatches({ team, selected_round }) {
		const { matches } = selected_round.attributes,
			real_score_arr = [],
			proj_score_arr = [],
			is_full_lockout = selected_round.is_full_lockout,
			team_players = this.getScoredTeamPlayers({ team, is_full_lockout })
		;

		let real_score = 0,
			proj_score = 0,
			is_proj_end = false
		;

		_.each(matches, _.bind(function(match) {
			const { home_squad_id, away_squad_id, status } = match,
				params = { home_squad_id, away_squad_id, team_players },
				match_players = this.getMatchPlayers(params),
				is_match_scheduled = status === 'scheduled',
				players_score = this.getPlayersScore({ match_players, is_match_scheduled })
			;

			if (!is_match_scheduled) {
				real_score += players_score;
			}

			proj_score += players_score;


			if (is_match_scheduled && !is_proj_end) {
				is_proj_end = true;
				proj_score_arr[proj_score_arr.length - 1] = real_score;
			}

			real_score_arr.push(is_match_scheduled ? null : real_score);
			proj_score_arr.push(is_match_scheduled ? proj_score : null);

		}, this));

		return {
			real_score_arr,
			proj_score_arr,
			real_score,
			proj_score
		}

	}

	getScoredTeamPlayers({ team, is_full_lockout }) {
		const { team_players, emergency_ids, not_counted_players } = team,
			arr_to_exclude = is_full_lockout ? not_counted_players : emergency_ids
		;

		return _.filter(team_players, player => !arr_to_exclude.includes(player.id))

	}

	getPlayersScore({ match_players, is_match_scheduled }) {
		return _.reduce(match_players, function(sum, player) {
			const score = _.result(player, `stats.points_last_round`, 0),
				proj_score =  _.result(player, `stats.proj_score`, 0),
				score_to_sum = is_match_scheduled ? proj_score : score
			;

			return _.isNumber(score_to_sum) ? sum + score_to_sum : sum;
		}, 0)
	}

	getMatchPlayers({ home_squad_id, away_squad_id, team_players }) {
		return _.filter(
			team_players, player => [home_squad_id, away_squad_id].includes(player.squad_id)
		)
	}

	countPlayers({ team, round, players }) {
		let starting_lineup_players = _.pickBy(
				this.getTeamLineupPLayersModels(team), player => player.bench_pos_name!=='EMG'
			),
			ytp = _.size(
				_.pickBy(
					starting_lineup_players,
					player => _.result(player, 'stats.points_last_round') === ''
				)
			) || '-',
			live_players = _.pickBy(starting_lineup_players, player => player.is_playing_now),
			live = _.size(live_players) || '-',
			final = _.size(
				_.pickBy(
					starting_lineup_players,
					player => _.result(player, 'stats.points_last_round') !== ''
						&&  !player.is_playing_now
				)
			) || '-',
			total_mins = this.total_match_mins * _.size(starting_lineup_players),
			live_mins = this.getLiveMinsRemain({ live_players, round, players }),
			remain_mins = this.total_match_mins * ytp + live_mins
		;

		team.set({
			ytp,
			live,
			final,
			total_mins,
			remain_mins
		}, { silent: true });

	}

	getLiveMinsRemain({ live_players, round, players }) {
		return _.reduce(live_players, function(result, player) {
			const player_model = players.get(player.id),
				player_match = player_model.getPlayerSquadMatch(round)
			;

			let mins = 0;

			if (player_match) {
				mins = this.getPlayerLiveMinsRemain(_.result(player_match, 'clock'));
			}

			return _.isNumber(mins) ? result + mins : result;
		}, 0);
	}


	getPlayerLiveMinsRemain(clock) {
		if (!clock) {
			return 0;
		}

		let k           = this.period_match_mins,
			period      = clock.p[1],
			calc_period = clock.s === -1 ? period : period - 1,
			mins        = parseInt(clock.s / 60, 10);
		return this.total_match_mins - (k * calc_period) - mins;
	}
}

export default MatchUpModel;